import { Button, Card, CardContent, CardMedia, Checkbox, CircularProgress, 
  FormControl, FormControlLabel, FormHelperText,  
  IconButton, InputAdornment, InputLabel, Link, OutlinedInput } from "@mui/material";
import Grid from '@mui/material/Grid2'
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import logo from "../../assets/logo.svg";
import logoNatale from "../../assets/LoginCloud-natale.svg"
import logoPasqua from "../../assets/LoginCloudPasqua.svg"

import { FormGroupCustom } from "../../Theme/ContainerStyle";
import { AlertLoginCustom } from "../../Theme/NotificheStyle";
import { TypographyLoginCustom } from "../../Theme/TextStyle";

export default function LoginForm(props) {
  const {loginError, sessionExpired, onSubmit, usernameHasError,
        username, onChangeUsername, isLoading, password, passwordHasError,
        showPassword, onChangePassword, onToggleShowPassword, onMouseDownPassword, rememberMe,
        onChangeRememberMe} = props

  // Determina se siamo nel periodo natalizio (dall'8 dicembre al 6 gennaio)
  const now = new Date();
  const month = now.getMonth(); // 0=Gennaio, 11=Dicembre
  const day = now.getDate();

  // Logica per determinare se mostrare logo natalizio
  // Se mese = Dicembre (11) e giorno >= 8
  // oppure se mese = Gennaio (0) e giorno <= 6
  // allora mostra logo natalizio
  const isChristmasTime = 
    (month === 11 && day >= 8) ||  // Dicembre dall'8 in poi
    (month === 0 && day <= 6);     // Gennaio fino al 6

  const currentLogo = isChristmasTime ? logoNatale : logo;

  return (
    <Grid container alignItems="center" spacing={4}>
      <Grid item size={{xs:12, md:5}}>
            {/* <img src={logo} alt="CloudControl Logo" className={classes.logo} />
            <Typography variant="h4" component="h1" align="center">
              <span className={classes.brandNameHead}>CLOUD</span>
              <span className={classes.brandNameTail}>CONTROL</span>
            </Typography> */}
        <CardMedia                               
          component="img"
          image={currentLogo}
          sx={{  objectFit: "contain"}}/>
      </Grid>
      <Grid item size={{xs:12, md:5}}>
        {loginError && (
          <AlertLoginCustom severity="error">
            {loginError}
          </AlertLoginCustom>
        )}
        {sessionExpired && (
          <AlertLoginCustom severity="error">
            La tua sessione è scaduta. Effettua nuovamente il login.
          </AlertLoginCustom>
        )}
        <Card variant="outlined">
          <CardContent>
            <form noValidate onSubmit={onSubmit}>
              <TypographyLoginCustom variant="h5" component="h2">
                Login
              </TypographyLoginCustom>
              <FormGroupCustom>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="username" error={usernameHasError}>
                    Username/Email
                  </InputLabel>
                  <OutlinedInput
                    id="username"
                    type="text"
                    value={username}
                    onChange={onChangeUsername}
                    label="Username/Email"
                    disabled={isLoading}
                    error={usernameHasError}
                  />
                  {usernameHasError && (
                    <FormHelperText error>
                      Campo richiesto.
                    </FormHelperText>
                  )}
                </FormControl>
              </FormGroupCustom>
              <FormGroupCustom>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="password" error={passwordHasError}>
                    Password
                  </InputLabel>
                  <OutlinedInput
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={onChangePassword}
                    label="Password"
                    disabled={isLoading}
                    required
                    error={passwordHasError}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                              onClick={onToggleShowPassword}
                              onMouseDown={onMouseDownPassword}
                              edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }/>
                  {passwordHasError && (
                    <FormHelperText error>
                      Campo richiesto.
                    </FormHelperText>
                  )}
                </FormControl>
              </FormGroupCustom>
              <FormGroupCustom>
                <FormControlLabel
                    label="Ricordami"
                    control={
                      <Checkbox
                          checked={rememberMe}
                          onChange={onChangeRememberMe}
                          color="primary"
                          disabled={isLoading}/>}
                />
              </FormGroupCustom>
              <FormGroupCustom>
                <Button variant="contained" color="primary" type="submit" disabled={isLoading}>
                  {isLoading && <CircularProgress size={24} />}
                  {!isLoading && "Login"}
                </Button>
              </FormGroupCustom>
              <Link href="#">Control panel</Link>
            </form>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}    
